import React, { useEffect } from "react";
import DayPicker, { DateUtils } from "react-day-picker";
import { mapCultureFromEpiServer } from "../DateUtil";
import { CalendarLocalization } from "./CalendarLocalization.csharp";

export interface CalendarProps {
    selectedDate: Date;
    range?: { from?: Date; to?: Date };
    onDateChange: (value: Date) => void;
    onRangeChange?: (range: { from?: Date; to?: Date }) => void;
    onBlur: () => void;
    onClose?: () => void;
    localization: CalendarLocalization;
}

const Calendar: React.FC<CalendarProps> = ({
    range,
    onDateChange,
    onRangeChange,
    onClose,
    localization,
    selectedDate,
}) => {
    const from = range?.from;
    const to = range?.to;

    const handleDayClick = (day: Date) => {
        if (!from || (from && to)) {
            onDateChange(day);
            onRangeChange?.({ from: day, to: undefined });
            console.log("[onDayClick] Resetting range: from =", day, "to = undefined");
        } else {
            const newRange = DateUtils.addDayToRange(day, { from, to });
            onRangeChange?.(newRange);
            console.log("[onDayClick] Completing range: from =", newRange.from, "to =", newRange.to);
        }

        console.log("[onDayClick] Clicked day:", day);
    };

    useEffect(() => {
        const wrapper = document.querySelector("div.DayPicker-wrapper") as HTMLElement | null;
        if (wrapper) wrapper.focus();
    }, []);

    const modifiers = { start: from, end: to };
    const selectedDays = (() => {
        if (from && to) {
            return [from, { from, to }];
        } else if (from) {
            return [from];
        } else if (selectedDate) {
            return [selectedDate];
        } else {
            return [];
        }
    })();

    return (
        <div className="DayPickerInput-OverlayWrapper">
            <div className="DayPickerInput-Overlay">
                <DayPicker
                    month={from || selectedDate || new Date()}
                    selectedDays={selectedDays}
                    onDayClick={handleDayClick}
                    locale={mapCultureFromEpiServer(localization.cultureName)}
                    months={localization.monthNames}
                    weekdaysLong={localization.weekDayLongNames}
                    weekdaysShort={localization.weekDayShortNames}
                    firstDayOfWeek={1}
                    modifiers={modifiers}
                />
                {onClose && (
                    <button
                        className="Calendar__close-button"
                        onClick={onClose}
                        type="button"
                        aria-label="Close calendar"
                    >
                        Lukk
                    </button>
                )}
            </div>
        </div>
    );
};

export default Calendar;
